import { useQuery } from 'react-query';

import type { LoadFileImportCompletionReport } from '../../../../backend/src/integrations/relativity/load-file-import/load-file-import-types';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

/**
 * Fetches the per-row results report for a completed load file import. Backs the
 * progress step's results table. After the Redis row preview expires, the API
 * returns persisted summary and audit-download metadata instead.
 */
const useGetLoadFileImportReport = (
  matterId: string | undefined,
  importId: string | undefined,
  options: { enabled?: boolean } = {},
) => {
  const { enabled = true } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getLoadFileImportReport = async (): Promise<LoadFileImportCompletionReport> => {
    const url = `${APIBaseChronos}/api/relativity/load-file-import/${importId}/report-rows?matterId=${matterId}`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch load file import report: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.LoadFileImportReport, { matterId, importId }], getLoadFileImportReport, {
    enabled: enabled && !!matterId && !!importId,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useGetLoadFileImportReport;
